import React from "react";
import { CTAButton } from "./CTAButton";
import { SectionHeading } from "./SectionHeading";
import { painPoints } from "../data/content";
export function PainPoints() {
  return <section className="w-full bg-navy px-4 py-16 sm:py-20" data-id="element-246" data-mp="26ypi16xo5ksv">
      <div className="mx-auto max-w-5xl" data-id="element-247" data-mp="26y60vsfuf0fw">
        <SectionHeading tone="dark" eyebrow="Does this sound familiar?" title="If you recognize yourself in even one of these situations…" subtitle="I created this system with you in mind." data-id="element-248" data-mp="2bx93l68coukp" />

        <ol className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-249" data-mp="220wdsjfxf0v8">
          {painPoints.map((point, i) => <li key={point.title} className="flex gap-4 rounded-2xl bg-navy-800 p-5 ring-1 ring-white/10 sm:p-6" data-id="element-250" data-mp="1o14uc36n4s9u" data-mpi={i}>
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gold font-serif text-lg font-bold text-navy" data-id="element-251" data-mp="1t0r6086tm0gj">
                {i + 1}
              </span>
              <div data-id="element-252" data-mp="3nbwi80vz3l7h">
                <h3 className="text-[17px] font-bold leading-snug text-white sm:text-lg" data-id="element-253" data-mp="3nabo2cdkm4a5">{point.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-white/70 sm:text-base" data-id="element-254" data-mp="1u1lm12egvf67">{point.body}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-10" data-id="element-255" data-mp="27sguweoytw9s">
          <CTAButton tone="dark" label="I'm done rebuilding my resources from scratch" note="One-Time Payment of $27 USD · Instant Digital Access · 7-Day Money-Back Guarantee" data-id="element-256" data-mp="23rdik264midb" />
        </div>
      </div>
    </section>;
}